import {
  appointmentBalanceState,
  appointmentCCState,
  appointmentCheckinState,
  appointmentDataTypeState,
  claimState,
  clinicalNoteStatus,
  superbillStatus
} from 'constants';

import {
  APPOINTMENT_RESOURCE_OPTIONS,
  APPOINTMENT_TAG_OPTIONS,
  PATIENT_OPTIONS,
  PROVIDER_OPTIONS,
  SERVICE_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

const appointmentConfirmState = [
  {
    value: true,
    label: 'Confirmeds'
  },
  {
    value: false,
    label: 'Unconfirmed'
  },
  {
    value: 'cancelled',
    label: 'Canceled'
  }
];

export const apptDefaultFilters = ({ arrivalStatuses }) => ({
  patient: PATIENT_OPTIONS,
  practitioner: PROVIDER_OPTIONS,
  resource: APPOINTMENT_RESOURCE_OPTIONS,
  serviceType: SERVICE_OPTIONS,
  appointmentTag: APPOINTMENT_TAG_OPTIONS,
  arrivalStatus: {
    title: 'Arrival status',
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: arrivalStatuses.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_arrival_status.options',
    icon: 'status-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  appointmentDataType: {
    title: 'Data type',
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: appointmentDataTypeState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_data_type.options',
    icon: 'list-unordered-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  confirmState: {
    title: 'Confirmation',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: appointmentConfirmState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_confirm_state.options',
    icon: 'checkbox-square-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  checkinState: {
    title: 'Checkin',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: appointmentCheckinState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_checkin_state.options',
    icon: 'checkbox-circle-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  balanceState: {
    title: 'Balance',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: appointmentBalanceState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_balance_state.options',
    icon: 'dollar-square-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  CCState: {
    title: 'Card on file',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: appointmentCCState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_cc_state.options',
    icon: 'card-check-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  clinicalNoteStatus: {
    title: 'Clinical note status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: clinicalNoteStatus.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_clinical_note_status.options',
    icon: 'status-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  superbillStatus: {
    title: 'Superbill',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: superbillStatus.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_superbill_status.options',
    icon: 'bill-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  claimState: {
    title: 'Claim',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: claimState.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'appointment_claim_state.options',
    icon: 'wallet-mono',
    allowed_operators: ['is', 'is any of', 'is not']
  }
});

export default apptDefaultFilters;
